import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import type {ReactNode} from 'react';

const muiSliderLtrEmotionCache = createCache({key: 'mui-slider-ltr'});

export function MuiSliderEmotionLtrProvider({children}: {children: ReactNode}) {
  return <CacheProvider value={muiSliderLtrEmotionCache}>{children}</CacheProvider>;
}
